export const BASE_PATH_TO_ADD_EXERCISE = "/exercises/add-exercise";